var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.titleList),function(item,index){return _c('el-breadcrumb-item',{key:index,staticClass:"breadcrumbBox"},[_vm._v(_vm._s(_vm.$i18n.locale=='zh'?item.title1:item.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }